import { environment } from '../../environments/environment';
import { EnvironmentConfiguration, EnvironmentConfigurationService, } from '@drc-eca/eca-lrc-common-ui';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LrcEnvironmentConfigurationService extends EnvironmentConfigurationService {
  constructor() {
    super();
  }

  getConfiguration(): EnvironmentConfiguration {
    return environment;
  }
}
